import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { dest, useAskInputActions, } from '#pplx/frontend/apps/ask/ask-input/ask-input-provider/components/AskInputProviderShared.js';
import { workspaceDirectorySyncKey } from '#pplx/frontend/apps/ask/ask-input/ask-input-types/index.js';
import React, { useEffect, useRef } from 'react';
/**
 * Syncs async thread metadata into the store once per provided metadata value.
 * This includes an empty list, which clears stale folders when navigating from
 * a workspace-scoped thread to one without workspace metadata.
 */
// WHY useEffect: syncing an external prop into a zustand store after async data arrives
const WorkspaceDirectorySync = ({ workspaceDirectories }) => {
    const lastSyncedKeyRef = useRef(undefined);
    const { setWorkspaceDirectories } = useAskInputActions();
    const syncKey = workspaceDirectorySyncKey(workspaceDirectories);
    useEffect(() => {
        if (syncKey === undefined || syncKey === lastSyncedKeyRef.current) {
            return;
        }
        setWorkspaceDirectories(workspaceDirectories ?? []);
        lastSyncedKeyRef.current = syncKey;
    }, [syncKey, workspaceDirectories, setWorkspaceDirectories]);
    return null;
};
const AskInputProvider = ({ children, workspaceDirectories }) => (_jsxs(dest.Provider, { initialValue: { workspaceDirectories }, children: [_jsx(WorkspaceDirectorySync, { workspaceDirectories: workspaceDirectories }), children] }));
export { AskInputProvider };
//# sourceMappingURL=AskInputProvider.js.map